import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_FUEL_RESET = 'PUT_FUEL_RESET';
export const PUT_FUEL_LOADING = 'PUT_FUEL_LOADING';
export const PUT_FUEL_SUCCESS = 'PUT_FUEL_SUCCESS';
export const PUT_FUEL_REJECT = 'PUT_FUEL_REJECT';

//* ACTIONS ------------------------------------------------
export const putFuelReset = () => ({ type: PUT_FUEL_RESET });
export const putFuelLoading = () => ({ type: PUT_FUEL_LOADING });
export const putFuelSuccess = (payload) => ({ type: PUT_FUEL_SUCCESS, payload });
export const putFuelReject = (payload) => ({ type: PUT_FUEL_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putFuelRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data: {
            idFuel: data.idFuel,
            fuelType: data.fuelType,
            startDate: data.startDate,
            endDate: data.endDate,
            price: data.price,
        },
    }, getState);
    return request(`/Fuels/web/UpdateFuels`, options);
};


